import EmploymentHistoryRecord from './EmploymentHistoryRecord';

export default EmploymentHistoryRecord;
